import React from 'react';
import { Button } from './ui/button';
import { Users, Radio } from 'lucide-react';

const AlphaCTA = () => {
  return (
    <section className="relative py-20 bg-gradient-to-b from-[#06070d] via-[#0b0e1a] to-[#06070d]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative bg-gradient-to-br from-[#f2e2a6]/10 to-transparent backdrop-blur-xl border border-[#f2e2a6]/20 rounded-3xl overflow-hidden">
          {/* Background effects */}
          <div className="absolute top-0 right-0 w-96 h-96 bg-[#f2e2a6]/20 rounded-full blur-3xl" />
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-purple-500/10 rounded-full blur-3xl" />

          <div className="relative grid lg:grid-cols-2 gap-12 p-12">
            {/* Left side - Content */}
            <div className="space-y-8">
              <div className="inline-block bg-white/5 px-4 py-2 rounded-lg border border-white/10">
                <span className="text-[#f2e2a6] text-sm font-mono uppercase tracking-wider">Community</span>
              </div>

              <h2 className="text-4xl md:text-5xl font-bold leading-tight">
                <span className="text-white">Trade with a</span>
                <br />
                <span className="text-[#f2e2a6]">Community.</span>
              </h2>

              <p className="text-gray-400 text-lg">
                Connect with other traders to share insights, discuss strategies, and stay informed about market movements.
              </p>

              <div className="grid grid-cols-2 gap-6">
                <div className="bg-black/40 backdrop-blur-xl border border-white/10 rounded-xl p-6 text-center">
                  <div className="text-4xl font-bold text-[#f2e2a6] mb-2">24/7</div>
                  <div className="text-gray-400 text-sm">Active Chat</div>
                </div>
                <div className="bg-black/40 backdrop-blur-xl border border-white/10 rounded-xl p-6 text-center">
                  <div className="text-4xl font-bold text-[#f2e2a6] mb-2">Free</div>
                  <div className="text-gray-400 text-sm">To Join</div>
                </div>
              </div>

              <div className="flex flex-wrap gap-4">
                <a href="https://t.me/ArbXSignalsBot" target="_blank" rel="noopener noreferrer">
                  <Button className="bg-[#f2e2a6] text-black hover:bg-[#f2e2a6]/90 font-semibold px-8 py-6 transition-all hover:scale-105">
                    Join the Telegram
                  </Button>
                </a>
              </div>
            </div>

            {/* Right side - Chat mockup */}
            <div className="bg-[#313338] border border-white/10 rounded-2xl overflow-hidden shadow-2xl">
              {/* Chat header */}
              <div className="bg-[#2b2d31] border-b border-white/10 px-6 py-4 flex items-center justify-between">
                <div className="flex items-center space-x-2">
                  <Radio className="w-4 h-4 text-[#f2e2a6] animate-pulse" />
                  <span className="text-white font-semibold">General Chat</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Users className="w-4 h-4 text-gray-400" />
                  <span className="text-gray-400 text-sm">Online</span>
                </div>
              </div>

              {/* Chat messages - no performance claims */}
              <div className="p-6 space-y-4 h-80 overflow-y-auto">
                <div className="flex items-start space-x-3">
                  <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-white text-xs font-bold">M</span>
                  </div>
                  <div>
                    <div className="flex items-center space-x-2 mb-1">
                      <span className="text-white text-sm font-semibold">Mark</span>
                      <span className="text-gray-500 text-xs">Yesterday</span>
                    </div>
                    <p className="text-gray-300 text-sm">The terminal UI looks clean. Easy to scan through opportunities.</p>
                  </div>
                </div>

                <div className="flex items-start space-x-3">
                  <div className="w-8 h-8 bg-purple-500 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-white text-xs font-bold">L</span>
                  </div>
                  <div>
                    <div className="flex items-center space-x-2 mb-1">
                      <span className="text-white text-sm font-semibold">Luke</span>
                      <span className="text-gray-500 text-xs">Today at 14:20</span>
                    </div>
                    <p className="text-gray-300 text-sm">Just set up my first alerts. Nice to have Telegram notifications. 👍</p>
                    <div className="flex items-center space-x-3 mt-2">
                      <span className="text-xs">🔥 12</span>
                      <span className="text-xs">👀 8</span>
                    </div>
                  </div>
                </div>

                <div className="flex items-start space-x-3">
                  <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-white text-xs font-bold">J</span>
                  </div>
                  <div>
                    <div className="flex items-center space-x-2 mb-1">
                      <span className="text-white text-sm font-semibold">Jane</span>
                      <span className="text-gray-500 text-xs">Now</span>
                    </div>
                    <p className="text-gray-300 text-sm">Anyone else tracking the NBA finals markets? Some interesting spreads showing up.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AlphaCTA;
